<template>
  <div class="l-mouse">
      <div class="icon">
        <l-img :src='src'></l-img>
      </div>
      
      <span class="tip">
        向下滚动
      </span>
  </div>
</template>

<script>
import mouse from '@/assets/img/mouse@2x.png'

export default {
    name: 'l-mouse',
    data(){
        return {
            src: mouse
        }
    }
}
</script>
<style lang="scss" scoped>
.l-mouse{
    margin-left: -18px;
    text-align: center;
    animation: upDown 2s infinite alternate; 
}

.icon{
    @include diamonds(36px);
    display: inline-block;

}


@keyframes upDown{
    0%{
        opacity: 1;        
        transform: translateY(-10px);
    }
    
    100%{
        opacity: .6;
        transform: translateY(10px);
    }
}

.tip{
    display: block;
    margin-top: 16px;
    font-size: $font_size_content;
    color: $font_color_light;
}

</style>